import {
	StatisticsHandler
// 	CustomerActivity,
// 	AbcStatistic,
// 	CheckSearch,
// 	Cards,
// 	ERPDate,
// 	Filials,
// 	Employees
} from './'
import {
	CustomerActivity,
	AbcStatistics,
	ERPDate,
	BillSearch,
	EmployeeTime,
	DayStatistics,
	Loyaltycards,
	ShopStatistic
} from './pages/'
import {
	getERPStatistics
} from './gql'
import { Profits } from 'media/icons'
import { isRouteDisabled } from 'sections/utils'

export default (t, rights) => ({
	id: '11',
	label: t('statistic_section.caption'),
	link: isRouteDisabled(rights, '11') ? null : 'statistik', // todo change main link
	linkDisabled: isRouteDisabled(rights, '11'),
	icon: Profits,
	subsections: [{
		name: 'Tagesstatistik',
		link: 'tagesstatistik',
		component: DayStatistics
	}, {
		name: t('statistic_section.sub_sections.customer_activity'),
		link: 'kundenfrequenzen',
		component: CustomerActivity
	}, {
		name: t('statistic_section.sub_sections.abc_statistic'),
		link: 'abc',	// todo change sbc link
		component: AbcStatistics
	}, {
		name: t('statistic_section.sub_sections.bill_search'),
		link: 'beleg-suchen',
		component: BillSearch
	}, {
    	name: t('statistic_section.strings.customer_card'),
    	link: 'kundenkarte',
    	component: Loyaltycards
	}, {
		name: t('statistic_section.sub_sections.erp_data'),
		link: 'erp-daten',
		component: ERPDate,
		statisticQuery: getERPStatistics
	}, {
		name: t('statistic_section.sub_sections.employeesData'),
		link: 'mitarbeiterzeit',
		component: EmployeeTime
	}, {
		name: t('statistic_section.sub_sections.shop_statistic'),
		link: 'filial-statistik',
		component: ShopStatistic
	}/*, {
		name: 'Filialen ohne daten',
		link: 'filialen',
		component: Filials
	}, {
		name: 'Mitarbeiterzahl',
		link: 'mitarbeiterzahl',
		component: Employees
	}*/],
	handler: StatisticsHandler
	// listQuery: 'listMedia',
	// itemQuery: 'getMedia'
})
